<template>
    <div class="h-100">
        <div id="disabled_layout" :class="{ on: disabledLayout }"></div>
        <router-view />
        <color-switcher />

        <newFooterVue v-if="$route.fullPath.includes('login') !== false" />
    </div>
</template>

<script>
import ColorSwitcher from "./components/Common/ColorSwitcher";
import newFooterVue from "./containers/newFooter.vue";
// import api from "./constants/api";

import {
    eventBus,
    getDirection
} from "./utils";
import {
    mapGetters,
    mapMutations,
    mapActions
} from "vuex";

export default {
    components: {
        "color-switcher": ColorSwitcher,
        newFooterVue
    },
    data() {
        return {
            disabledLayout: false,
            userRole: null,
            message2: '',
        }
    },
    beforeMount() {
        const direction = getDirection();
        if (direction.isRtl) {
            document.body.classList.add("rtl");
            document.dir = "rtl";
            document.body.classList.remove("ltr");
        } else {
            document.body.classList.add("ltr");
            document.dir = "ltr";
            document.body.classList.remove("rtl");
        }
    },
    methods: {
        ...mapMutations(['setMessaging']),
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName'])
    },
    mounted() {

        let vm = this;
        vm.initPostMessageListener();
        this.$messaging.onMessage(payload => {
            let vm = this;
            vm.userRole = vm.currentUser.userRole.split('_')[0];
            if (vm.userRole !== "STORE") {
                return;
            } else {
                console.log(payload);
                eventBus.$emit('bus-event-messaging', payload, false);
            }
        })


    },
    beforeDestroy() {
        eventBus.$off('bus-event-messaging', this.initPostMessageListener)
    },
    created() {
        eventBus.$on('bus-event', flag => {
            console.log(this.disabledLayout);
            this.disabledLayout = flag;
        })
    },
    methods: {
        initPostMessageListener() {
            let vm = this;
            navigator.serviceWorker.addEventListener('message', function (e) {
                console.log(e.data)
                
                var message = e.data;
                // console.log('1')
                this.message2 = e.data;
                eventBus.$emit('bus-event-messaging', message, true);
            });

        }
    }
};
</script>

<style>
#disabled_layout {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
    position: absolute;
    /*background-color: #000;*/
    display: none;
}

#disabled_layout.on {
    display: block;
}

.newFooterP {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 0;
    background: #dedede;
    padding: 20px;
}

.newFooterP p {
    margin-bottom: 0;
}
</style>
